import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const beneVerifyThisPAN = createAsyncThunk(
  "beneVerifyThisPAN",
  async (values, { rejectWithValue }) => {
    try {
      const pan_number = values?.pan_number || values?.search_string;

      const response = await axiosInstance.post(
        `${baseUrl}/verification/pan/verify`,
        { pan: pan_number },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return rejectWithValue(undefined);
      }

      const errData = error?.response?.data || {
        status: false,
        message: "Something went wrong",
      };

      return rejectWithValue(errData);
    }
  },
);

export const benePANLookUp = createAsyncThunk(
  "benePANLookUp",
  async (values) => {
    const { pan_number } = values ? values : { pan_number: null };

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary/lookup`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            pan: pan_number,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const beneVerifyThisBank = createAsyncThunk(
  "beneVerifyThisBank",
  async (values, { rejectWithValue }) => {
    const { bank_account, ifsc_code, legal_name, navigate } = values;

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/verification/bank_account/verify`,
        { bank_account, ifsc_code, legal_name },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response?.data?.errors?.user_unauthorized) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BUAccount",
          },
        });
      } else {
        CommonToast({
          text: error.response?.data?.error,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
      return rejectWithValue(
        error.response?.data?.errors?.base
          ? error.response?.data?.errors?.base[0]
          : error.response?.data?.errors?.bank_account
            ? error.response?.data?.errors?.bank_account[0]
            : "An error occurred",
      );
    }
  },
);

export const beneVerifyThisIFSC = createAsyncThunk(
  "beneVerifyThisIFSC",
  async (values) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/ifsc/${values?.search_string}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: values?.page_no,
            page_size: values?.page_size,
          },
        },
      );

      if (response.data?.errors) {
        CommonToast({
          text: response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return response.data;
    } catch (error) {
      console.error("Error", error);
      throw error?.response?.data?.errors?.base[0];
    }
  },
);

export const beneBankLookUp = createAsyncThunk(
  "beneBankLookUp",
  async (values) => {
    const { bank_account_no, ifsc } = values
      ? values
      : { bank_account_no: null, ifsc: null };

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary/lookup`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            bank_account_no: bank_account_no,
            ifsc: ifsc,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const getSpecificGST = createAsyncThunk(
  "getSpecificGST",
  async (values, { rejectWithValue }) => {
    const { gst_number } = values ? values : { gst_number: null };
    const token = sessionStorage.getItem("q2p_token");
    const gstin = gst_number || values?.search_string;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/gstin/${gstin}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      // CommonToast({
      //   text: errorMessage,
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });
      return rejectWithValue(errorMessage);
    }
  },
);

export const beneVerifyThisGST = createAsyncThunk(
  "beneVerifyThisGST",
  async (values, { rejectWithValue }) => {
    try {
      const { gstin } = values || {};

      const payload = {
        gstin: gstin || values?.search_string,
      };

      const response = await axiosInstance.post(
        `${baseUrl}/verification/gstin/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return undefined;
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const beneVerifyThisCIN = createAsyncThunk(
  "beneVerifyThisCIN",
  async (values) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/cin/` + values?.search_string,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.errors) {
        CommonToast({
          text: response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return response.data;
    } catch (error) {
      CommonToast({
        text: error,

        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      console.error("Error", error);
      throw error;
    }
  },
);

export const beneVerifyThisDIN = createAsyncThunk(
  "beneVerifyThisDIN",
  async (values) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/din/` + values?.search_string,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.errors) {
        CommonToast({
          text: response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return response.data;
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  },
);

export const beneCategories = createAsyncThunk(
  "beneCategories",
  async (values) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transaction_categories`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            search_string: values?.search_string,
            sort_by: values?.sort_by,
            category_type: values?.category_type,
            category_status: values?.category_status,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  },
);

export const beneCreateNewAccount = createAsyncThunk(
  "beneCreateNewAccount",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/accounts/beneficiary`,
        values,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error creating account:", error);
      return rejectWithValue(error.message);
    }
  },
);

export const uploadImages = createAsyncThunk(
  "uploadImages",
  async (values, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", values);
      const response = await axiosInstance.post(
        `${baseUrl}/images/upload`,
        formData,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const beneViewAllAcc = createAsyncThunk(
  "beneViewAllAcc",
  async (values) => {
    const {
      page_no,
      page_size,
      approval_status,
      categoryName,
      search_string,
      bank_account_no,
      ifsc,
      start_date,
      end_date,
      pan,
      type,
      labels,
      reimbursement_account,
      associate,
    } = values;
    try {
      const buildUrl = () => {
        let r = `${baseUrl}/accounts/`;
        switch (type) {
          case "internalAccount":
            r += "internal";
            break;
          case "reimbursementAccount":
            r += "reimbursement";
            break;
          case "beneAccount":
          default:
            r += "beneficiary";
            break;
        }
        return r;
      };
      const response = await axiosInstance.get(buildUrl(), {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page_no,
          page_size: page_size,
          approval_status: associate
            ? associate
            : approval_status && approval_status?.length !== 0
              ? type === "homeDashboard"
                ? approval_status
                : [approval_status]
              : type === "homeDashboard"
                ? []
                : "",
          category: categoryName,
          search_string: search_string,
          start_date,
          end_date,
          bank_account_no: bank_account_no,
          ifsc: ifsc,
          pan: pan,
          labels: labels,
          reimbursement_account: reimbursement_account,
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.errors?.base[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  },
);

export const unAssignCategories = createAsyncThunk(
  "unAssignCategories",
  async (values) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: values.page_no,
            approval_status: ["pending", "approved", "rejected"],
            category: values.categoryName,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const beneViewAllAprroved = createAsyncThunk(
  "beneViewAllAprroved",
  async (values, { getState }) => {
    const { approval_status } = getState().beneAllVerification;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            approval_status: approval_status,
            internal_account: values?.type === "internalAccount" ? "Y" : "N",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const beneDashboard = createAsyncThunk(
  "beneDashboard",
  async ({ page, page_size, type, reimbursement_account }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page,
            page_size: page_size,
            internal_account: type === "internalAccount" ? "Y" : "N",
            reimbursement_account: reimbursement_account,
          },
        },
      );
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  },
);

export const beneRequiredApproval = createAsyncThunk(
  "beneRequiredApproval",
  async (values) => {
    const {
      page_no,
      page_size,
      categoryName,
      search_string,
      bank_account_no,
      ifsc,
      start_date,
      end_date,
      pan,
      labels,
      reimbursement_account,
      type_of_account,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            approval_status: ["pending"],
            page_no: page_no,
            page_size: page_size,
            category: categoryName,
            search_string: search_string,
            start_date,
            end_date,
            bank_account_no: bank_account_no,
            ifsc: ifsc,
            pan: pan,
            labels: labels,
            type_of_account: type_of_account,
            reimbursement_account: reimbursement_account ? "Y" : "",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const beneWaitingApproved = createAsyncThunk(
  "beneWaitingApproved",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/approve`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return rejectWithValue(undefined);
      }

      const errData = error?.response?.data || {
        status: false,
        message: "Something went wrong",
      };

      return rejectWithValue(errData);
    }
  },
);

export const beneDeniedAccount = createAsyncThunk(
  "beneDeniedAccount",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      const data = {
        rejection_reason: AccountIdData,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return undefined;
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const beneVerifyThisBankNames = createAsyncThunk(
  "beneVerifyThisBankNames",
  async () => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/bank/bank_list/`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.errors) {
        CommonToast({
          text: response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return response.data;
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  },
);

export const addNewLabel = createAsyncThunk(
  "addNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabels") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabels", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.INFO_FILLED,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const removeNewLabel = createAsyncThunk(
  "removeNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.INFO_FILLED,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.INFO_FILLED,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

const beneAllVerification = createSlice({
  name: "beneAllVerification",
  initialState: {
    storedPage: 1,
    toggle: false,
    isblur: false,
    beneAccountAvailableLabels: [],

    isPANError: false,
    isBankError: false,
    isIFSCError: false,
    isCINError: false,
    isDINError: false,
    isTransCateError: false,
    isCreateAccountError: false,
    isError: false,
    status: "idle",
    isGSTError: false,
    isPANLoading: false,
    isCINLoading: false,
    isDINLoading: false,
    getGSTLoading: false,
    isGSTLoading: false,
    isTransCateLoading: false,
    isCreateAccountLoading: false,
    beneVerifyPAN: null,
    verifyBank: null,
    bankMessage: "",
    verifyIFSC: null,
    beneVerifyGST: null,
    beneVerifyCIN: null,
    beneVerifyDIN: null,
    beneLookData: null,
    beneLookLoading: null,
    beneLookError: null,

    addLabelsLoading: true,
    addLabelsData: [],
    addLabelsError: false,

    removeLabelsLoading: true,
    removeLabelsData: [],
    removeLabelsError: false,

    benePanLookData: null,
    benePanLookLoading: null,
    benePanLookError: null,

    beneunachivedData: null,
    beneunachivedLoading: null,
    beneunachivedError: null,
    beneTransCategories: {
      categories: [],
    },
    beneViewAllAccData: null,
    beneViewAllAccLoading: null,
    beneViewAllAccError: null,

    beneDashboardAccData: null,
    beneDashboardAccLoading: null,
    beneDashboardAccError: null,

    beneRequiredApprovalData: null,
    beneRequiredApprovalLoading: null,
    beneRequiredApprovalError: null,

    beneWaitingApprovalData: null,
    beneWaitingApprovalLoading: null,
    beneWaitingApprovalError: null,

    beneDeniedApprovalData: null,
    beneDeniedApprovalLoading: null,
    beneDeniedApprovalError: null,

    beneDetailDenyAccData: null,
    beneDetailDenyAccLoading: null,
    beneDetailDenyAccError: null,

    uploadImagesLoading: null,
    uploadImagesData: null,
    uploadImagesError: null,

    beneVerifyThisBankNamesData: [],
    beneVerifyThisBankNamesLoading: true,
    beneVerifyThisBankNamesError: null,

    unAssignCategoryData: null,
    unAssignCategoryLoading: false,
  },
  reducers: {
    resetVerification(state) {
      state.beneVerifyPAN = null;
      state.verifyBank = null;
    },
    setAvailabelLabels: (state, action) => {
      state.beneAccountAvailableLabels = action.payload;
    },
    resetBeneBankData(state) {
      state.beneLookData = null;
    },
    resetPANVerification(state) {
      state.beneVerifyPAN = null;
    },
    resetGSTVerification(state) {
      state.beneVerifyGST = null;
      state.isGSTLoading = false;
      state.isGSTError = false;
      state.status = "idle";
    },
    resetBankVerification(state) {
      state.verifyBank = null;
    },
    resetBankError(state) {
      state.isBankError = null;
    },
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },

    setIsBlur(state, action) {
      state.isblur = action.payload;
    },

    resetToggle: (state) => {
      state.toggle = false;
    },
    resetViewAllAcc: (state) => {
      state.beneViewAllAccData = null;
      state.beneViewAllAccLoading = null;
      state.beneViewAllAccError = null;
    },
    resetBeneVerifyThisGst: (state) => {
      state.isGSTLoading = null;
      state.beneVerifyGST = null;
      state.isGSTError = null;
    },

    resetLabelLoading: (state) => {
      state.addLabelsLoading = false;
      state.removeLabelsLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addNewLabel.pending, (state, action) => {
      state.addLabelsLoading = true;
    });
    builder.addCase(addNewLabel.fulfilled, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsData = action.payload;
    });
    builder.addCase(addNewLabel.rejected, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsError = action.payload;
      state.addLabelsData = null;
    });
    builder.addCase(removeNewLabel.pending, (state, action) => {
      state.removeLabelsLoading = true;
    });
    builder.addCase(removeNewLabel.fulfilled, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsData = action.payload;
    });
    builder.addCase(removeNewLabel.rejected, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsError = action.payload;
      state.removeLabelsData = null;
    });

    builder.addCase(beneDeniedAccount.pending, (state, action) => {
      state.beneDeniedApprovalLoading = true;
    });
    builder.addCase(beneDeniedAccount.fulfilled, (state, action) => {
      state.beneDeniedApprovalLoading = false;
      state.beneDeniedApprovalData = action.payload;
    });
    builder.addCase(beneDeniedAccount.rejected, (state, action) => {
      state.beneDeniedApprovalError = true;
      state.beneDeniedApprovalData = null;
      state.beneDeniedApprovalLoading = false;
    });

    builder.addCase(beneWaitingApproved.pending, (state, action) => {
      state.beneWaitingApprovalLoading = true;
    });
    builder.addCase(beneWaitingApproved.fulfilled, (state, action) => {
      state.beneWaitingApprovalLoading = false;
      state.beneWaitingApprovalData = action.payload;
    });
    builder.addCase(beneWaitingApproved.rejected, (state, action) => {
      state.beneWaitingApprovalError = true;
      state.beneWaitingApprovalData = null;
      state.beneWaitingApprovalLoading = false;
    });
    builder.addCase(beneRequiredApproval.pending, (state, action) => {
      state.beneRequiredApprovalLoading = true;
    });
    builder.addCase(beneRequiredApproval.fulfilled, (state, action) => {
      state.beneRequiredApprovalLoading = false;
      state.beneRequiredApprovalData = action.payload;
    });
    builder.addCase(beneRequiredApproval.rejected, (state, action) => {
      state.beneRequiredApprovalError = true;
      state.beneRequiredApprovalData = null;
    });

    builder.addCase(beneDashboard.pending, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.beneAccountAvailableLabels = [];
      }
      state.beneDashboardAccLoading = true;
    });
    builder.addCase(beneDashboard.fulfilled, (state, action) => {
      state.beneAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabels",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.beneDashboardAccLoading = false;
      state.beneDashboardAccData = action.payload;
    });
    builder.addCase(beneDashboard.rejected, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.beneAccountAvailableLabels = [];
      }
      state.beneDashboardAccError = true;
      state.beneDashboardAccLoading = false;
      state.beneDashboardAccData = null;
    });
    builder.addCase(beneViewAllAcc.pending, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.beneAccountAvailableLabels = [];
      }
      state.beneViewAllAccLoading = true;
    });
    builder.addCase(beneViewAllAcc.fulfilled, (state, action) => {
      state.beneAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabels",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.beneViewAllAccLoading = false;
      state.beneViewAllAccData = action.payload;
    });
    builder.addCase(beneViewAllAcc.rejected, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.beneAccountAvailableLabels = [];
      }
      state.beneViewAllAccLoading = false;
      state.beneViewAllAccError = true;
      state.beneViewAllAccData = null;
    });

    builder.addCase(beneBankLookUp.pending, (state, action) => {
      state.beneLookLoading = true;
      state.beneLookError = false;
    });
    builder.addCase(beneBankLookUp.fulfilled, (state, action) => {
      state.beneLookLoading = false;
      state.beneLookData = action.payload;
    });
    builder.addCase(beneBankLookUp.rejected, (state, action) => {
      state.beneLookError = true;
      state.beneLookData = null;
      state.beneLookLoading = false;
    });
    builder.addCase(benePANLookUp.pending, (state, action) => {
      state.benePanLookLoading = true;
    });
    builder.addCase(benePANLookUp.fulfilled, (state, action) => {
      state.benePanLookLoading = false;
      state.benePanLookData = action.payload;
    });
    builder.addCase(benePANLookUp.rejected, (state, action) => {
      state.benePanLookError = true;
      state.benePanLookData = null;
    });
    builder.addCase(beneVerifyThisPAN.pending, (state, action) => {
      state.verifyPANisLoading = true;
    });
    builder.addCase(beneVerifyThisPAN.fulfilled, (state, action) => {
      state.isPANLoading = false;
      state.beneVerifyPAN = action.payload;
    });
    builder.addCase(beneVerifyThisPAN.rejected, (state, action) => {
      state.isError = true;
    });
    builder.addCase(beneVerifyThisBank.pending, (state, action) => {
      state.verifyBankisLoading = true;
    });
    builder.addCase(beneVerifyThisBank.fulfilled, (state, action) => {
      state.verifyBankisLoading = false;
      state.isBankError = false;
      state.verifyBank = action.payload;
      state.bankMessage = "";
    });
    builder.addCase(beneVerifyThisBank.rejected, (state, action) => {
      state.isBankError = true;
      state.verifyBank = null;
      state.verifyBankisLoading = false;
      state.bankMessage = action.payload;
    });
    builder.addCase(beneVerifyThisCIN.pending, (state, action) => {
      state.isCINLoading = true;
    });
    builder.addCase(beneVerifyThisCIN.fulfilled, (state, action) => {
      state.isCINLoading = false;
      state.verifyCIN = action.payload;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload?.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(beneVerifyThisCIN.rejected, (state, action) => {
      state.isError = true;
    });
    builder.addCase(beneVerifyThisDIN.pending, (state, action) => {
      state.isDINLoading = true;
    });
    builder.addCase(beneVerifyThisDIN.fulfilled, (state, action) => {
      state.isDINLoading = false;
      state.verifyDIN = action.payload;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(beneVerifyThisDIN.rejected, (state, action) => {
      state.isError = true;
    });
    builder.addCase(getSpecificGST.pending, (state, action) => {
      state.getGSTLoading = true;
      state.beneVerifyGST = null;
      state.status = "loading";
    });
    builder.addCase(getSpecificGST.fulfilled, (state, action) => {
      state.getGSTLoading = false;
      state.beneVerifyGST = action.payload;
      state.status = "fulfilled";
    });
    builder.addCase(getSpecificGST.rejected, (state, action) => {
      state.getGSTLoading = false;
      state.isGSTError = true;
      state.beneVerifyGST = null;
      state.status = "rejected";
    });
    builder.addCase(beneVerifyThisGST.pending, (state, action) => {
      state.isGSTLoading = true;
      state.status = "loading";
    });
    builder.addCase(beneVerifyThisGST.fulfilled, (state, action) => {
      state.isGSTLoading = false;
      state.beneVerifyGST = action.payload;
      state.status = "fulfilled";
    });
    builder.addCase(beneVerifyThisGST.rejected, (state, action) => {
      state.isGSTError = true;
      state.status = "rejected";
    });
    builder.addCase(beneVerifyThisIFSC.pending, (state, action) => {
      state.verifyIFSCisLoading = true;
    });
    builder.addCase(beneVerifyThisIFSC.fulfilled, (state, action) => {
      state.verifyIFSC = action.payload;
      state.verifyIFSCisLoading = false;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(beneVerifyThisIFSC.rejected, (state, action) => {
      state.verifyIFSCisLoading = false;
      state.isError = action;
    });
    builder.addCase(beneCategories.pending, (state, action) => {
      state.isTransCateLoading = true;
    });
    builder.addCase(beneCategories.fulfilled, (state, action) => {
      state.isTransCateLoading = false;
      state.beneTransCategories = action.payload;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(beneCategories.rejected, (state, action) => {
      state.isTransCateError = true;
    });
    builder.addCase(beneCreateNewAccount.pending, (state, action) => {
      state.isCreateAccountLoading = true;
      state.isCreateAccountError = null;
    });
    builder.addCase(beneCreateNewAccount.fulfilled, (state, action) => {
      state.isCreateAccountLoading = false;
      state.createdAccount = action.payload;
    });
    builder.addCase(beneCreateNewAccount.rejected, (state, action) => {
      state.isCreateAccountLoading = false;
      state.isCreateAccountError = action.error.message;
    });

    builder.addCase(uploadImages.pending, (state) => {
      state.uploadImagesLoading = true;
    });
    builder.addCase(uploadImages.fulfilled, (state, action) => {
      state.uploadImagesLoading = false;
      state.uploadImagesData = action.payload;
    });
    builder.addCase(uploadImages.rejected, (state, action) => {
      state.uploadImagesLoading = false;
      state.uploadImagesError = action.payload;
    });
    builder.addCase(beneVerifyThisBankNames.pending, (state, action) => {
      state.beneVerifyThisBankNamesLoading = true;
    });
    builder.addCase(beneVerifyThisBankNames.fulfilled, (state, action) => {
      state.beneVerifyThisBankNamesLoading = false;
      state.beneVerifyThisBankNamesData = action.payload;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(beneVerifyThisBankNames.rejected, (state, action) => {
      state.beneVerifyThisBankNamesError = true;
    });
    builder.addCase(unAssignCategories.pending, (state) => {
      state.unAssignCategoryLoading = true;
    });
    builder.addCase(unAssignCategories.fulfilled, (state, action) => {
      state.unAssignCategoryLoading = false;
      state.unAssignCategoryData = action.payload;
    });
    builder.addCase(unAssignCategories.rejected, (state) => {
      state.unAssignCategoryLoading = false;
    });
  },
});

export const {
  resetVerification,
  resetPANVerification,
  resetGSTVerification,
  resetBankVerification,
  resetBeneBankData,
  resetBankError,
  resetpage,
  setStoredPage,
  resetToggle,
  setToggle,
  setIsBlur,
  resetViewAllAcc,
  resetLabelLoading,
  resetBeneVerifyThisGst,
  setAvailabelLabels,
} = beneAllVerification.actions;

export default beneAllVerification.reducer;
